import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/TwitterTools.css';

const CreatorToolsHub = () => {
    const navigate = useNavigate();

    const creatorTools = [
        {
            name: 'YouTube Comment Picker',
            description: 'Randomly select winners from YouTube video comments. Perfect for giveaways and contests on your channel.',
            route: '/youtube-comment-picker',
            icon: '🎯',
            color: '#ff0000'
        },
        {
            name: 'Twitch Chat Picker',
            description: 'Pick random winners from your Twitch chat using keywords. Fair and transparent giveaways for your stream.',
            route: '/twitch-picker',
            icon: '🎮',
            color: '#9147ff'
        }
    ];

    return (
        <div className="twitter-tools-container">
            <div className="tools-header">
                <div className="badge-featured">Creator Suite</div>
                <h1>🎬 Creator Tools</h1>
                <p>Powerful tools to enhance your content creation workflow</p>
            </div>

            <div className="tools-info-banner-hub">
                <div className="banner-content">
                    <div className="banner-icon">🎯</div>
                    <div className="banner-text">
                        <h3>Fair & Transparent</h3>
                        <p>
                            All selection tools use cryptographically secure randomization to ensure
                            every participant has an exactly equal chance to win.
                        </p>
                    </div>
                </div>
            </div>

            <div className="tools-grid-hub">
                {creatorTools.map((tool, index) => (
                    <div
                        key={index}
                        className="tool-card-hub"
                        style={{ '--tool-color': tool.color }}
                        onClick={() => navigate(tool.route)}
                    >
                        <div className="tool-card-glow"></div>
                        <div className="tool-icon-hub" style={{
                            background: `linear-gradient(135deg, ${tool.color} 0%, ${tool.color}dd 100%)`,
                            boxShadow: `0 8px 30px ${tool.color}40`
                        }}>
                            {tool.icon}
                        </div>
                        <h3 className="tool-name-hub">{tool.name}</h3>
                        <p className="tool-description-hub">{tool.description}</p>
                        <div className="tool-footer-hub">
                            <span className="credit-cost"></span>
                            <button
                                className="tool-use-btn"
                                style={{
                                    background: `linear-gradient(135deg, ${tool.color} 0%, ${tool.color}dd 100%)`
                                }}
                            >
                                Use Tool →
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            <div className="info-section">
                <h2>ℹ️ Creator Tools Features</h2>
                <div className="info-grid">
                    <div className="info-card">
                        <div className="info-icon">🎯</div>
                        <h3>Fair Selection</h3>
                        <p>
                            Cryptographically secure random selection ensures every comment has an equal chance.
                            No bias, no manipulation - just pure randomness.
                        </p>
                    </div>
                    <div className="info-card">
                        <div className="info-icon">⚡</div>
                        <h3>Real-time Data</h3>
                        <p>
                            Fetch comments directly from YouTube's API. Get the most current comment data
                            for accurate and up-to-date selections.
                        </p>
                    </div>
                    <div className="info-card">
                        <div className="info-icon">🛡️</div>
                        <h3>Privacy Focused</h3>
                        <p>
                            We only access the data you provide. Comments are processed securely
                            and not stored permanently on our servers.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreatorToolsHub;